/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ArenasMethods,
  ArenasMethodsInterface,
  ArenasConstructor,
} from "../ArenasMethods";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "alphadune",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "uint256",
            name: "alphadunePercentage",
            type: "uint256",
          },
        ],
        internalType: "struct ArenasConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "EditArena",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "NewArena",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "arena",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "arenaOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "arenas",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "token_uri",
        type: "string",
      },
      {
        internalType: "address",
        name: "platformAndArenaFeeCurrency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "platformAndArenaFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "arenaMap",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "surface",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "distance",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "weather",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "payments",
        type: "address",
      },
      {
        internalType: "address",
        name: "alphadune",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "alphadunePercentage",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "handleArenaUsage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFeeCurrency",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "alphadune",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "uint256",
            name: "alphadunePercentage",
            type: "uint256",
          },
        ],
        internalType: "struct ArenasConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ArenasMethodsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ArenasMethodsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ArenasMethods__factory extends ContractFactory {
  constructor(...args: ArenasMethodsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ArenasMethods";
  }

  deploy(
    input: ArenasConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ArenasMethods> {
    return super.deploy(input, overrides || {}) as Promise<ArenasMethods>;
  }
  getDeployTransaction(
    input: ArenasConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): ArenasMethods {
    return super.attach(address) as ArenasMethods;
  }
  connect(signer: Signer): ArenasMethods__factory {
    return super.connect(signer) as ArenasMethods__factory;
  }
  static readonly contractName: "ArenasMethods";
  public readonly contractName: "ArenasMethods";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ArenasMethodsInterface {
    return new utils.Interface(_abi) as ArenasMethodsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ArenasMethods {
    return new Contract(address, _abi, signerOrProvider) as ArenasMethods;
  }
}
